export const transformAddress = (addressLine1: string, addressLine2?: string) => {
  return addressLine1 + (addressLine2 ? `, ${addressLine2}` : '')
}
